

    <div *ngIf="usersToDisplay">
      Assigned users: {{usersToDisplay}}
    </div>
<nz-radio-group *ngIf="currentUser?.makeAreas" style="padding: 10px;" [(ngModel)]="segment" (ngModelChange)="segmentChange($event)" nzButtonStyle="solid">
    <label nz-radio-button [nzValue]="'info'">
      <span nz-icon nzType="info-circle" nzTheme="outline"></span>
    </label>
  
    <label nz-radio-button [nzValue]="'users'">
      <span nz-icon nzType="user" nzTheme="outline"></span>
    </label>
  
    <label nz-radio-button [nzValue]="'disposition'">
      <span nz-icon nzType="file-text" nzTheme="outline"></span>
    </label>
  </nz-radio-group>

<nz-card *ngIf="segment == 'info'" nzTitle="Total Pins">
    <nz-statistic [nzValue]="totalPins"></nz-statistic>
</nz-card>

<nz-radio-group  *ngIf="segment == 'info'" style="padding: 10px;" [(ngModel)]="subSegment" (ngModelChange)="subSegmentChange($event)" nzButtonStyle="solid">
  <label nz-radio-button [nzValue]="'graph'">
    <span nz-icon nzType="pie-chart" nzTheme="outline"></span>
  </label>

  <label nz-radio-button [nzValue]="'list'">
    <span nz-icon nzType="unordered-list" nzTheme="outline"></span>
  </label>

</nz-radio-group>

<nz-card style="margin-top: 5px;" [ngClass]="{ 'hidden': totalPins === 0 || segment !== 'info' || subSegment !== 'graph' }" nzTitle="Pins by Disposition">
    <canvas #pieChart width="400" height="400"></canvas>
</nz-card>

<nz-card style="margin-top: 5px;" [ngClass]="{ 'hidden': totalPins === 0 || segment !== 'info' || subSegment !== 'list' }" nzTitle="Pins by Disposition">
  <nz-list>
      <nz-list-item *ngFor="let disp of sortArr(modal?.data?.pinsByDispositions)">
        <span nz-typography>{{disp.disposition}}</span>
        {{disp.count}}
      </nz-list-item>
  </nz-list>
</nz-card>

<form *ngIf="segment == 'users'" [formGroup]="usersForm">

    <nz-form-item>
        <nz-form-label>Select User(s)</nz-form-label>
        <nz-select [compareWith]="compareFn" nzMode="multiple" nzPlaceHolder="Select Rep" formControlName="users" style="width: 100%;" [nzShowSearch]="true">
          <nz-option *ngFor="let u of users" [nzLabel]="u.first_name + ' ' + u.last_name + ' (' + u.company + ')'" [nzValue]="u"></nz-option>
        </nz-select>
    </nz-form-item>

    <nz-form-item>
        <nz-form-label>Color</nz-form-label>
        <nz-color-picker formControlName="color"></nz-color-picker>
        <!-- <input style="width: 100%;" type="color" formControlName="color"/> -->
    </nz-form-item>

</form>

<form *ngIf="segment == 'disposition'" [formGroup]="dispForm">

    <nz-form-item>
        <nz-form-label>Select a disposition</nz-form-label>
        <nz-select nzPlaceHolder="Select disposition" formControlName="disposition" style="width: 100%;">
          <nz-option *ngFor="let disp of dispositions" [nzValue]="disp.id" [nzLabel]="disp.disposition"></nz-option>
        </nz-select>
    </nz-form-item>

    <nz-form-item>
      <nz-form-label>Select pins to disposition</nz-form-label>
      <nz-select nzMode="multiple" nzPlaceHolder="Select pins" formControlName="pinsToChange" style="width: 100%;">
        <nz-option *ngFor="let disp of modal.data.pinsByDispositions" [nzValue]="disp.disposition_id" [nzLabel]="disp.disposition"></nz-option>
      </nz-select>
  </nz-form-item>



  </form>

<button style="width: 100%;" nz-button nzType="primary" expand="block" (click)="update()" *ngIf="segment == 'users' && currentUser?.makeAreas">Update Area</button>
<button style="width: 100%;" [nzLoading]="saving" [disabled]="dispForm.invalid" nz-button nzType="primary" expand="block" (click)="massDisp()" *ngIf="segment == 'disposition' && currentUser?.makeAreas">Mass Disposition Area</button>
<button *ngIf="currentUser?.makeAreas" nzDanger nz-button nzType="primary" (click)="delete()" style="margin-top: 5px; width: 100%;">Delete Area</button>
<button nz-button nzType="default" (click)="cancel()" style="margin-top: 5px; width: 100%;">Close</button>